import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

import { IonItem, IonText, IonIcon } from "@ionic/vue";
import { withDefaults } from "vue";
import useRoles from "@/hooks/useRole";
import { RoleEnum } from "@/generated/graphql";


const __default__ = {
  name: "ChooseBlock",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    value: {},
    icon: {},
    disabled: { type: Boolean, default: false },
    isWebItem: { type: Boolean, default: false },
    itemOutline: { type: Boolean, default: false },
    isLightItem: { type: Boolean, default: false },
    detailIcon: { type: Boolean, default: true },
    dangerTitle: { type: Boolean },
    isInactive: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    fontLatoBold: { type: Boolean, default: false },
    webEventItem: { type: Boolean, default: false },
    addBorder: { type: Boolean, default: false },
    endIconColor: { default: "var(--gray-400)" },
    borderColor: { default: "var(--gray-600)" }
  },
  emits: ["handle-click"],
  setup(__props: any, { emit: emits }) {

const { role } = useRoles();





const onClick = () => {
  emits("handle-click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    disabled: _ctx.disabled,
    class: _normalizeClass(["choose-place", {'web-item': _ctx.isWebItem, 'light-item': _ctx.isLightItem, 'in-active': _ctx.isInactive, 'active': _ctx.isActive, 'font-lato-bold': _ctx.fontLatoBold, 'dark-value': _ctx.webEventItem, 'item-border': _ctx.addBorder }]),
    onClick: onClick,
    fill: _ctx.itemOutline ? 'outline' : undefined,
    lines: _ctx.isWebItem ? 'none' : undefined,
    style: _normalizeStyle({
    '--end-icon-color': _ctx.endIconColor,
    '--item-border': _ctx.borderColor
   })
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonText), {
        class: _normalizeClass(["choose-place__label", {'trainer-label-color': _unref(role) === _unref(RoleEnum).Trainer, 'danger-title': _ctx.dangerTitle}]),
        slot: "start"
      }, {
        default: _withCtx(() => [
          (_ctx.icon)
            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                key: 0,
                src: `assets/icon/${_ctx.icon}.svg`,
                class: "choose-place__icon--start"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(IonText), {
        class: _normalizeClass(["choose-place__value", {'native-app': _unref(role) === _unref(RoleEnum).Trainer }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.value), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      (_ctx.detailIcon)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 0,
            class: "choose-place__icon",
            slot: "end",
            src: "assets/icon/arrow-next.svg"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["disabled", "class", "fill", "lines", "style"]))
}
}

})